// Validators
// Input validation functions

import { PHONE_CONSTANTS } from '../config/constants.js';

/**
 * Validate Chilean phone number format
 * Expected: +569XXXXXXXX (12 characters total)
 *
 * @param {string} phone - Phone number to validate
 * @returns {boolean} Whether phone is valid
 */
export function validatePhone(phone) {
    if (!phone) return false;
    return PHONE_CONSTANTS.PATTERN.test(phone);
}

/**
 * Validate email format
 *
 * @param {string} email - Email to validate
 * @returns {boolean} Whether email is valid
 */
export function validateEmail(email) {
    if (!email) return false;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}

/**
 * Validate rating value (1-5)
 *
 * @param {number|string} rating - Rating to validate
 * @returns {boolean} Whether rating is valid
 */
export function validateRating(rating) {
    const ratingNum = parseInt(rating);
    return !isNaN(ratingNum) && ratingNum >= 1 && ratingNum <= 5;
}

/**
 * Sanitize string input (prevent XSS)
 *
 * @param {string} input - Input to sanitize
 * @returns {string} Sanitized input
 */
export function sanitizeInput(input) {
    if (!input) return '';

    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
}

/**
 * Format phone number as user types
 * Ensures it always starts with +569
 *
 * @param {string} value - Current input value
 * @returns {string} Formatted phone number
 */
export function formatPhoneInput(value) {
    if (!value.startsWith(PHONE_CONSTANTS.PREFIX)) {
        return PHONE_CONSTANTS.PREFIX;
    }
    return value;
}

/**
 * Prevent deletion of phone prefix
 *
 * @param {KeyboardEvent} event - Keyboard event
 * @param {HTMLInputElement} input - Input element
 */
export function preventPrefixDeletion(event, input) {
    if (input.selectionStart < PHONE_CONSTANTS.PREFIX.length && event.key === 'Backspace') {
        event.preventDefault();
    }
}
